import { data } from '../../svg/GridView/data';
import { makeIcon } from '../makeIcon';

export const GridView = makeIcon(data, 'grid_view', 'GridView');

export default GridView;
